import { ModalDialog } from '@front10/base-elements';
import { OverlayContainer } from '@react-aria/overlays';
import { useOverlayTriggerState } from '@react-stately/overlays';
import useStyles from '@front10/helpers/dist/UseStyles';
import * as React from 'react';
import Button from '../../../../packages/base-elements/Button2';
import { CloseButton } from '../../../../packages/base-elements/CloseButton';
import { Box, Text } from '@front10/base-elements';
import { ThemeProvider } from '@front10/base-elements';
import { EmotionCache } from '../../../containers/_commons/emotionCache';
import { Context } from '@front10/helpers/dist/Context';

export function ButtonTerms({
  terms,
  onClick,
  onClose,
  labelBottomTerms = 'cmp-terms-btn',
  labelTitleTerms = 'cmp-terms-title',
  buttonSettings = {
    sx: {
      '&:focus': { boxShadow: 'none' },
      fontSize: '12px',
      height: '24px',
      padding: '5px 0px 0px 0px',
      textTransform: 'none',
      textDecoration: 'underline'
    }
  },
  closeButtonSettings = { color: '#757575' },
  containerSettings = {},
  titleTermsContainerSettings = {
    'cmp-styles': {
      display: 'flex',
      'flex-direction': 'row',
      'flex-wrap': 'nowrap',
      'justify-content': 'center',
      height: '62px',
      'background-color': '#EEEEEE',
      'align-items': 'center'
    },
    paddingLeft: '21px'
  },
  titleTermsSettings,
  termsContainerSettings = { padding: '42.63px 23px 42.63px 28px' },
  textTermsSettings,
  isMobile = false
}) {
  let state = useOverlayTriggerState({});

  const { translate, theme, direction } = React.useContext(Context);

  const [titleTermsClass] = useStyles(titleTermsContainerSettings, { direction, theme });

  const term = terms ? terms.split('\n') : '';

  return (
    <EmotionCache direction={direction}>
      <ThemeProvider theme={theme.designTokens ?? undefined}>
        <Button
          onPress={() => {
            state.open();
            onClick?.();
          }}
          variant="link"
          {...buttonSettings}
        >
          {translate(labelBottomTerms, 'Promotion Terms & Conditions')}
        </Button>
        {state.isOpen && (
          <OverlayContainer>
            <ModalDialog
              isOpen
              onClose={() => {
                state.close();
                onClose?.();
              }}
              isDismissable
              size={isMobile ? 'fullscreen' : 'default'}
            >
              <Box className={titleTermsClass}>
                <Text {...titleTermsSettings}>
                  {translate(labelTitleTerms, 'TERMS AND CONDITIONS')}
                </Text>
              </Box>
              <CloseButton
                {...closeButtonSettings}
                onPress={() => {
                  state.close();
                  onClose?.();
                }}
              />

              <Box
                sx={{
                  isolation: 'isolate',
                  maxHeight: '100vh',
                  maxWidth: '604px',
                  minWidth: '375px',
                  overflow: 'auto'
                }}
                {...containerSettings}
              >
                <Box
                  sx={{
                    isolation: 'isolate',
                    maxHeight: '100vh',
                    maxWidth: '604px',
                    minWidth: '375px',
                    overflow: 'auto'
                  }}
                  {...termsContainerSettings}
                >
                  {Array.isArray(term)
                    ? term.map((item) => (
                        <>
                          <Text>{item}</Text>
                          <br></br>
                        </>
                      ))
                    : term}
                </Box>
              </Box>
            </ModalDialog>
          </OverlayContainer>
        )}
      </ThemeProvider>
    </EmotionCache>
  );
}
